// src/utils/generateGreeting.js

export const generateGreeting = () => {
  const now = new Date();
  const hour = now.getHours();
  const day = now.toLocaleString('en-US', { weekday: 'long' });

  let timeOfDay = 'day';
  if (hour < 12) timeOfDay = 'morning';
  else if (hour < 18) timeOfDay = 'afternoon';
  else timeOfDay = 'evening';

  return `Good ${timeOfDay}`;;
};